























































































































































































































































































































































































































import {
  EventManagementCreateEventItemRequest,
  EventManagementCreateEventRequest,
  EventManagementEventService,
  EventManagementReadEventCsvResponseApiRespoonse,
} from "@/common/api";
import { LANG } from "@/common/constant";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import EventItemsComponent from "@/components/admin/event/common/eventItemsComponent.vue";
import EventAddCarpPopupComponent from "@/components/admin/event/eventAddCarpPopupComponent.vue";
import EventAddCertificatePopupComponent from "@/components/admin/event/eventAddCertificatePopupComponent.vue";
import CsvDropzoneComponent from "@/components/common/csvDropzoneComponent.vue";
import LanguageComponent from "@/components/common/languageComponent.vue";
import QEditor from "@/components/common/qEditor.vue";
import QLanguageTab from "@/components/common/qLanguageTab.vue";
import QReleaseSetting from "@/components/common/qReleaseSetting.vue";
import QReleaseSettingEvent from "@/components/common/qReleaseSettingEvent.vue";
import QSelect from "@/components/common/qSelect.vue";
import QUploadSingleImage from "@/components/common/qUploadSingleImage.vue";
import {
  DEFAULT_IMAGE_KEYS,
  DEFAULT_IMAGES,
  STATUS_SELECT_ARRAY,
} from "@/model/event";
import store from "@/store";
import { keyBy, map, merge, omitBy, sortBy, unionWith } from "lodash";
import camelCase from "lodash/camelCase";
import capitalize from "lodash/capitalize";
import cloneDeep from "lodash/cloneDeep";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import transform from "lodash/transform";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const event = namespace("Event");

@Component({
  name: "EventEditComponent",
  components: {
    QReleaseSettingEvent,
    EventAddCarpPopupComponent,
    EventAddCertificatePopupComponent,
    CsvDropzoneComponent,
    LanguageComponent,
    EventItemsComponent,
    QSelect,
    QCalendar,
    QEditor,
    QLanguageTab,
    QReleaseSetting,
    QErrors,
    QUploadSingleImage,
  },
})
export default class EventEditComponent extends Vue {

  get disabled() {
    return !this.$router.currentRoute.params.id;
  }

  get contextLangList() {
    const langEn = this.languages.en;
    const langCn = this.languages.cn;

    return [...[LANG.JA], ...(langEn ? ["en"] : []), ...(langCn ? ["cn"] : [])];
  }

  get defaultThumbnails() {
    return DEFAULT_IMAGES;
  }

  get currentImageComputed() {
    if (this.form.isUploadThumbnails) {
      return this.image?.name;
    } else {
      return this.defaultThumbnailComputed[this.form.thumbnailNo];
    }
  }

  get defaultThumbnailComputed() {
    return DEFAULT_IMAGES;
  }
  @event.Action
  public updateEvent: (event) => void;
  public title = "店頭イベントの新規作成";
  public contentImages = [];
  public errors = {};
  public isEditing = false;
  public languages = {
    ja: true,
    en: true,
    cn: false,
  };
  public contextLanguages = [LANG.EN, LANG.CN];
  public dateConfig = {
    enableTime: true,
    dateFormat: "Y-m-d H:i",
    defaultHour: 12,
  };
  public statusList = STATUS_SELECT_ARRAY;
  public contextLang = LANG.JA;
  public entryDate = null;
  public entryHour = null;
  public entryMinute = null;
  public uploading = false;
  public uploadOptions = {
    acceptedFiles: ".jpg, .jpeg, .png",
    maxFilesize: 5, // 5mb
  };
  public image = {
    id: null,
    name: null,
  };

  public form = {
    id: null,
    title: "",
    titleEn: "",
    titleCn: "",
    startDatetime: "",
    endDatetime: "",
    isPreEntry: true,
    preEntryEndTime: "",
    isUploadThumbnails: false,
    thumbnailNo: DEFAULT_IMAGE_KEYS.IMAGE_1,
    imageId: null,
    context: "",
    contextEn: "",
    contextCn: "",
    openStatus: EventManagementCreateEventRequest.openStatus.EDIT,
    releaseSetting: null,
    postDate: null,
    eventItems: [],
  };
  public originalForm;
  public isPhotoUploaded = false;
  public isCertUploaded = false;
  public isShowLoadingPhotoUpload = false;
  public isShowLoadingCertUpload = false;
  public zipFile;
  public zipFileImage;
  public zipImage;

  public connection: WebSocket;
  public connectionId = null;

  private id;

  public created() {
    this.id = Number(this.$router.currentRoute.params.id);
    if (this.id) {
      this.connectSocket(this.id);
      this.isEditing = true;
      this.getEvent(this.id);
    }
  }

  public async mounted() {
    if (!this.id) {
      this.originalForm = cloneDeep(this.form);
    }
  }

  public beforeDestroy() {
    if (this.connection) {
      this.connection.close();
      this.connection = null;
    }
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public changeEntryDate(): void {
    let entryTime = null;
    if (this.entryDate) {
      this.entryHour = Math.min(Math.max(0, this.entryHour), 23);
      this.entryMinute = Math.min(Math.max(0, this.entryMinute), 59);
      const hours = this.entryHour.toString().padStart(2, "0");
      const minutes = this.entryMinute.toString().padStart(2, "0");
      entryTime = moment(`${this.entryDate} ${hours}:${minutes}`).format(
        "YYYY-MM-DD HH:mm",
      );
    }

    this.form.preEntryEndTime = entryTime;
  }

  public changeThumbnailSetting() {
    if (!this.form.isUploadThumbnails) {
      this.form.thumbnailNo = DEFAULT_IMAGE_KEYS.IMAGE_1;
    } else {
      this.form.thumbnailNo = null;
    }
  }

  public changeThumbnailImage(id = null, name = null) {
    this.image = {
      id,
      name,
    };
  }

  public changeFile(file) {
    this.form.imageId = file ? file.id : null;
    this.changeThumbnailImage(file.id, file.filePath);
  }

  public uploadStatus(flag) {
    this.uploading = flag;
  }

  public async uploadCsv(file) {
    const formData = new FormData();
    formData.append("csv", file);
    const result = await EventManagementEventService.adminEventCsv(
      formData as any,
    );
    this.changeCsv(result);
  }

  public changeCsv({ data }: EventManagementReadEventCsvResponseApiRespoonse) {
    delete data.event.id;
    delete data.event.release_setting;
    delete data.event.post_date;
    delete data.event.open_status;
    const originalItems = this.form.eventItems;

    const items = keyBy(data.event.event_items, "code");
    this.form.eventItems = unionWith(
      this.form.eventItems,
      this.convertObjectToCamelCase(data.event.event_items),
      (a, b) => a.code === b.code,
    );
    delete data.event.event_items;

    this.form = {
      ...this.form,
      ...this.convertObjectToCamelCase({
        ...omitBy(data.event, (v) => v === "" || !v),
        thumbnail_no: data.event.thumbnail_no || DEFAULT_IMAGE_KEYS.IMAGE_1,
      }),
      ...{
        isPreEntry: data.event.is_pre_entry || this.form.isPreEntry || true,
        isUploadThumbnails:
          data.event.is_upload_thumbnails ||
          this.form.isUploadThumbnails ||
          false,
        thumbnailNo: data.event.thumbnail_no || this.form.thumbnailNo,
      },
    };

    map(this.form.eventItems, (row) => {
      if (items[row.code]) {
        const item = items[row.code];
        row = merge(
          row,
          this.convertObjectToCamelCase({
            ...omitBy(item, (v) => v === "" || !v),
          }),
        );
        const original = originalItems.find((row) => {
          return row.code === item.code;
        });
        row.status = original
          ? original.status
          : (item.status as EventManagementCreateEventItemRequest.status);
      }
    });

    this.form.eventItems = sortBy(this.form.eventItems, "code");
  }

  public async submit() {
    this.errors = {};
    let result;

    try {
      if (this.isEditing) {
        result = await EventManagementEventService.adminEventEdit(this.form);
      } else {
        result = await EventManagementEventService.adminEventCreate(this.form);
      }

      if (result.status == "success") {
        this.id = result.data.event.id;
        this.form.id = this.id;
        this.isEditing = true;
        QNotify.success({
          text: this.$t("common.message.created"),
        });

        await this.$router.push({ name: "admin.event.index" });
      }
    } catch (error) {
      result = error;
      QNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
        if ("context" in this.errors) {
          this.contextLang = LANG.JA;
        } else if ("contextEn" in this.errors) {
          this.contextLang = LANG.EN;
        } else if ("contextCn" in this.errors) {
          this.contextLang = LANG.CN;
        }
        (this.$refs.eventItems as any).getPageError(this.errors);
      }
    }
  }

  public cancel() {
    const diff = compareWithKeys(
      this.form,
      this.originalForm,
      Object.keys(this.form),
    );

    if (!diff) {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        onConfirm: () => {
          this.$router.back();
        },
      });
    } else {
      this.$router.back();
    }
  }

  public async delete() {
    this.errors = {};

    try {
      const result = await EventManagementEventService.adminEventDelete({
        id: this.id,
      });

      if (result.status == "success") {
        QNotify.success({
          text: this.$t("common.message.created"),
        });

        await this.$router.back();
      }
    } catch (error) {
      const result = error;
      QNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      }
    }
  }

  public preview() {
    this.updateEvent(
      cloneDeep({
        ...this.form,
        image: {
          id: this.form.isUploadThumbnails
            ? this.image.id
            : this.form.thumbnailNo,
          name: this.currentImageComputed,
        },
      }),
    );
    window.open("/event/preview", "_blank");
  }

  public async sharedPreview() {
    this.errors = {};

    try {
      const result =
        await EventManagementEventService.adminEventGenerateSharedPreviewUrl({
          id: this.id,
        });

      if (result.status == "success") {
        window.open(result.data.shared_preview_url, "_blank", "noreferrer");
      }
    } catch (error) {
      const result = error;
      QNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      }
    }
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: this.$t("common.message.delete_confirm"),
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.delete();
      },
    });
  }

  public confirmCancel() {
    this.$modal.showCancel({
      text: this.$t("common.message.cancel_confirm"),
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.$router.back();
      },
    });
  }

  public async generateCert(certData) {
    if (this.disabled) { return; }

    try {
      const { is_display_code, is_display_price, date, signature } = certData;
      const publishDate = moment({
        year: Number(date.year),
        month: Number(date.month) - 1,
        day: Number(date.day),
      }).format("YYYY-MM-DD");

      const data = {
        id: Number(this.$router.currentRoute.params.id),
        isDisplayCode: is_display_code,
        isDisplayPrice: is_display_price,
        publishDate,
        signName: signature,
      };
      this.isShowLoadingCertUpload = true;
      this.isCertUploaded = false;

      const {
        data: { result },
      } = await EventManagementEventService.adminEventGenerateZipCert(data);

      if (!result) { throw new Error("生成に失敗しました"); }
    } catch (error) {
      this.showError(error);
    }
  }

  public async generateCarp(carpData) {
    if (this.disabled) { return; }

    try {
      const { language } = carpData;

      const data = {
        id: Number(this.$router.currentRoute.params.id),
        language,
      };
      this.isShowLoadingPhotoUpload = true;
      this.isPhotoUploaded = false;

      const {
        data: { result },
      } = await EventManagementEventService.adminEventGenerateZipImage(data);

      if (!result) { throw new Error("生成に失敗しました"); }
    } catch (error) {
      this.showError(error);
    }
  }

  public setZipFileCert(zipFile) {
    this.isCertUploaded = zipFile.type == "event_cert";
    this.isShowLoadingCertUpload = false;
    this.zipFile = zipFile;
  }

  public setZipFileImage(zipFile) {
    this.isPhotoUploaded = zipFile.type == "event_image";
    this.isShowLoadingPhotoUpload = false;
    this.zipFileImage = zipFile;
  }

  public showError(error) {
    const message = error.body.message;
    QNotify.error({
      text: message,
    });
  }

  public getDefaultThumbnailUrl(name) {
    return "/images/default/" + name;
  }

  public capitalizeLang(lang) {
    return capitalize(lang);
  }

  public convertObjectToCamelCase(object) {
    return transform(object, (accumulator, value, key, target) => {
      const camelKey = isArray(target) ? key : camelCase(key as string);

      accumulator[camelKey] = isObject(value)
        ? this.convertObjectToCamelCase(value)
        : value;
    }) as any;
  }

  public async exportZipFile() {
    if (!this.zipFile) { return; }

    const {
      data: { url },
    } = await EventManagementEventService.adminEventExportZip({
      id: this.zipFile.id,
    });
    window.open(url, "_blank", "noreferrer");
  }

  public async exportZipImage() {
    if (!this.zipFileImage) { return; }

    const {
      data: { url },
    } = await EventManagementEventService.adminEventExportZip({
      id: this.zipFileImage.id,
    });
    window.open(url, "_blank", "noreferrer");
  }

  public async connectSocket(eventId) {
    const result = await EventManagementEventService.adminEventConnectSocketUrl(
      { event_id: eventId },
    );
    this.connection = new WebSocket(result.data.connect_socket_url);
    this.connection.addEventListener("message", (event: MessageEvent) => {
      const data = JSON.parse(event.data);
      if (data.action === "subcribe") {
        this.connectionId = data.connectionId;
      }
    });
    this.connection.addEventListener("open", () => {
      const body: any = {
        action: "subscribe",
        topic: "change-event-status/" + eventId,
      };

      this.connection.send(JSON.stringify(body));
    });
  }

  public hasRole(roles: string | string[]) {
    const roleArray = Array.isArray(roles) ? roles : [roles];
    return roleArray.includes(store.state.Auth.admin_user.role.name);
  }

  private async getEvent(id) {
    const {
      data: { event },
    } = await EventManagementEventService.adminEventView({ id });

    this.form = this.convertObjectToCamelCase(event);
    this.title = event.title + "の編集";
    if (this.form.preEntryEndTime) {
      const preEntryDate = moment(this.form.preEntryEndTime);
      this.entryDate = preEntryDate.format("YYYY-MM-DD");
      this.entryHour = preEntryDate.hours();
      this.entryMinute = preEntryDate.minutes();
    }
    if (this.form.isUploadThumbnails) {
      this.image = {
        id: event.image?.id || null,
        name: event.image?.name || null,
      };
    }
    this.originalForm = cloneDeep(this.form);
  }
}
